import { Button, Icon, Spinner } from '@tb/ui';
import { shortenAddressForDisplay } from '../lib/format';
import { useWalletContext } from '../auth/WalletProvider';
import { useT } from '../i18n/LocaleProvider';

export function WalletBar() {
  const wallet = useWalletContext();
  const t = useT();

  if (wallet.status === 'ready') {
    return (
      <button
        type="button"
        className="wallet-chip"
        onClick={() => void wallet.disconnect()}
        title={t('wallet.disconnect')}
      >
        <Icon name="wallet" size={14} />
        {shortenAddressForDisplay(wallet.wallet.friendlyAddress)}
      </button>
    );
  }

  if (wallet.status === 'verifying' || wallet.status === 'connecting') {
    return <Spinner size={18} label={t('wallet.connecting')} />;
  }

  return (
    <Button size="sm" variant="secondary" icon="connect" onClick={() => void wallet.connect()}>
      {t('wallet.connect')}
    </Button>
  );
}
